export enum RegistrationActionType {
  Stocking = 1,
  Transfer = 2,
  Harvest = 3,
  Feeding = 4,
  Treatment = 5,
  WaterQuality = 6,
  MeanweightSample = 7,
}
